import React from 'react';

// Shared pagination control used across DailyBusiness/StockCheck/LiterStatement
// list views, which previously each hand-rolled the same page-window math with
// slightly different markup/colors.
const Pagination = ({ currentPage, totalPages, onPageChange, className = '' }) => {
  if (totalPages <= 1) return null;

  const pageWindow = 1;
  const pages = [];
  for (let p = 1; p <= totalPages; p++) {
    const isEdge = p === 1 || p === totalPages;
    const isNearCurrent = Math.abs(p - currentPage) <= pageWindow;
    if (isEdge || isNearCurrent) {
      pages.push(p);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  return (
    <nav className={`flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap ${className}`} aria-label="Pagination">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="w-10 h-10 rounded-lg sm:rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 hover:bg-primary hover:text-white hover:border-primary transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-slate-800 disabled:hover:text-slate-600 dark:disabled:hover:text-slate-300 flex items-center justify-center shadow-sm"
        aria-label="Previous page"
      >
        <i className="fas fa-chevron-left text-xs"></i>
      </button>

      {pages.map((page, idx) =>
        page === '...' ? (
          <span key={`ellipsis-${idx}`} className="px-1.5 sm:px-2 text-slate-400 dark:text-slate-500 text-sm">&hellip;</span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            aria-current={page === currentPage ? 'page' : undefined}
            className={`min-w-[2.5rem] h-10 px-2 sm:px-3 rounded-lg sm:rounded-xl text-sm font-semibold transition-all duration-200 shadow-sm ${
              page === currentPage
                ? 'bg-gradient-to-r from-primary to-primary-dark text-white shadow-primary/30'
                : 'bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 hover:border-primary/40 hover:text-primary'
            }`}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="w-10 h-10 rounded-lg sm:rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 hover:bg-primary hover:text-white hover:border-primary transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-slate-800 disabled:hover:text-slate-600 dark:disabled:hover:text-slate-300 flex items-center justify-center shadow-sm"
        aria-label="Next page"
      >
        <i className="fas fa-chevron-right text-xs"></i>
      </button>
    </nav>
  );
};

export default Pagination;
